import {
  Box,
  Tooltip,
  styled,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Suspense } from "react";
import { PersonalLayer } from "types/types";
import { LayerActions } from "./LayerActions";
import { OpacitySlider } from "./OpacitySlider";
import { useUpdatePersonalLayer } from "hooks/layerHooks";

interface Props {
  personalLayer: PersonalLayer;
  selectedPersonalLayerIds: number[];
  removePersonalLayerParams: (id: number) => void;
}

export function PersonalLayerItem(props: Props) {
  const { personalLayer, selectedPersonalLayerIds, removePersonalLayerParams } =
    props;

  const { mutateAsync: update } = useUpdatePersonalLayer();

  async function onChangeOpacity(value: number | number[]) {
    if (Array.isArray(value)) return;
    update({
      ...personalLayer,
      wms: { ...personalLayer.wms, opacity: value / 100 },
    });
  }

  const isChecked = selectedPersonalLayerIds.indexOf(personalLayer.id) !== -1;
  return (
    <StyledBox className="item">
      <Box className="flex-item">
        <Tooltip title={personalLayer.name}>
          <FormControlLabel
            control={<Checkbox />}
            checked={isChecked}
            value={personalLayer.id}
            label={personalLayer.name}
          />
        </Tooltip>
        <Suspense>
          <LayerActions
            layer={personalLayer}
            removePersonalLayerParams={removePersonalLayerParams}
          />
        </Suspense>
      </Box>
      {isChecked && (
        <OpacitySlider
          opacity={personalLayer.wms.opacity}
          onChangeOpacity={onChangeOpacity}
        />
      )}
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  .flex-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
  }
  .MuiTypography-root {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MuiFormControlLabel-root {
    overflow: hidden;
  }
`;
